import { eventBlockClasses } from "./utils/variant-classes.js";
import "react";
import { Dropdown } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Calendar/EventTrigger.tsx
function EventTrigger(props) {
	const className = `${props.className ?? ""} ${eventBlockClasses(props.event)}`.trim();
	const body = /* @__PURE__ */ jsxs(Fragment$1, { children: [
		props.segment.clippedStart && /* @__PURE__ */ jsx("span", {
			"aria-hidden": true,
			children: "▴ "
		}),
		props.renderEventContent?.(props.event, props.segment),
		props.segment.clippedEnd && /* @__PURE__ */ jsx("span", {
			"aria-hidden": true,
			children: " ▾"
		})
	] });
	if (props.onEventClick) return /* @__PURE__ */ jsx("button", {
		className,
		onClick: (e) => {
			e.stopPropagation();
			props.onEventClick?.(props.event);
		},
		type: "button",
		children: body
	});
	return /* @__PURE__ */ jsx(Dropdown, {
		className: "block h-full min-w-full",
		controller: ({ open }) => /* @__PURE__ */ jsx("button", {
			className,
			onClick: (e) => {
				e.stopPropagation();
				open();
			},
			type: "button",
			children: body
		}),
		dropdownPlace: props.dropdownPlace,
		children: props.renderEventDetail?.(props.event)
	});
}
//#endregion
export { EventTrigger };

//# sourceMappingURL=EventTrigger.js.map